import { render, staticRenderFns } from "./Recepcion.vue?vue&type=template&id=7472bcc3&"
import script from "./Recepcion.vue?vue&type=script&lang=js&"
export * from "./Recepcion.vue?vue&type=script&lang=js&"
import style0 from "./Recepcion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports